import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { generateColorMap } from "@/modules/vue/utils";
export default /*#__PURE__*/_defineComponent({
  __name: 'GridItem',
  props: {
    color: null
  },
  setup(__props) {
    const props = __props;
    const colorMap = ref(generateColorMap({
      bg: 50,
      text: 600
    }));
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([colorMap.value[__props.color], "flex flex-col items-center justify-center p-2 rounded text-4xl cursor-pointer"])
      }, [_renderSlot(_ctx.$slots, "default")], 2);
    };
  }
});